import { render, staticRenderFns } from "./TrainerBio.vue?vue&type=template&id=7d751ed6"
import script from "./TrainerBio.vue?vue&type=script&lang=js"
export * from "./TrainerBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports